
import React from 'react'

export const CategoryBanner = () =>{
    return (
        <div className='banner flex colorparty'>
            <div>
                <h1>UI/UX DESIGN</h1>
                <p> 
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quis, corporis! 
                    Dolorum aut voluptates, vitae rem quae reiciendis facere nemo architecto 
                    maxime neque distinctio nostrum nulla rerum dolore saepe natus quod.
                </p>
            </div>
            <div className='flex-end'>
                <div className="members">

                </div>
                <div className="actions">
                   
                </div>
            </div>
        </div>
    )
}